import { useMutation, useQueryClient } from 'react-query';
import { joinCompetition } from 'api/services/competitions';

const useJoinCompetition = (onSuccess, onError) => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation({
    mutationFn: async (competitionId) => {
      await joinCompetition(competitionId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries('getJoinedCompetitions');
      await queryClient.refetchQueries('getJoinedCompetitions');
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error?.errorMessage || 'Something went wrong');
    },
  });

  return {
    mutate,
  };
};

export default useJoinCompetition;
